import {
  check,
  lengthLessEqualThan,
  packValidateResults,
  required,
  validateParam,
  validator,
} from 'helpers/validators';
import { IPWhitelistMutationRequest } from 'services/API/IPWhitelist/interface';

const cidr: validateParam = (data: IPWhitelistMutationRequest, fields, options = {}) =>
  check(fields, (field) => {
    const value = `${(data as any)?.[field] ?? ''}`.trim();

    if (!value) {
      return;
    }

    const isRange = !value.includes('%') && validator.isIPRange(value);
    if (!isRange) {
      return options.err_msg || ['error_invalid_cidr_format'];
    }
  });

export const validate = (data: IPWhitelistMutationRequest) =>
  packValidateResults([
    required(data, ['ip_address']),
    cidr(data, ['ip_address']),
    lengthLessEqualThan(data, ['description'], { max: 255 }),
  ]);
